import PubSub from "underpub-js";
import gsap from 'gsap';

var NavBar = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-NavBar',
	};

	$.extend(true, this.options, options);

};

NavBar.prototype.init = function() {

	var self = this;

	this.$hamburger = this.options.$el.find(`.${self.options.baseClass}__hamburger`);
	this.$hamburgerLines = this.options.$el.find(`.${self.options.baseClass}__hamburger span`);

	this.initAnimationTimelines();

	this.$hamburger.on('click', function() {

		self.hamburgerOutTimeline.restart();

	});

	PubSub.subscribe('NavBar:showHamburger', function() {
	    
		self.hamburgerInTimeline.restart();

	});

};

NavBar.prototype.initAnimationTimelines = function() {

	var self = this;

	this.hamburgerOutTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.25,
			top: 8,
			ease: "power1.inOut"
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.05"
	)
	.call(function() {
		PubSub.publish('NavOverlay:show');
	}, null, ">-0.1");

	this.hamburgerInTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.35,
			width: 28,
			ease: "power3.out"
		}
	)
	.to(this.$hamburgerLines.eq(0),
		{
			duration: 0.35,
			top: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	)
	.to(this.$hamburgerLines.eq(2),
		{
			duration: 0.35,
			top: 16,
			ease: "power1.inOut"
		},
		"<"
	)
	;

};

export default NavBar;
